var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSouthkorea({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1739 12C16.1739 13.0435 14.3052 15.6522 12 15.6522C9.69483 15.6522 7.82611 13.0435 7.82611 12C7.82611 9.69478 9.69483 7.82611 12 7.82611C14.3052 7.82611 16.1739 9.69478 16.1739 12Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1739 12C16.1739 14.3052 14.3052 16.1739 12 16.1739C9.69483 16.1739 7.82611 14.3052 7.82611 12",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4238 15.6894L17.5304 14.5828L18.2682 15.3206L17.1616 16.4272L16.4238 15.6894Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5789 17.5338L15.6855 16.4272L16.4233 17.165L15.3167 18.2716L14.5789 17.5338Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6372 17.9025L19.7438 16.7959L20.4815 17.5337L19.375 18.6403L18.6372 17.9025Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7924 19.7472L17.899 18.6406L18.6367 19.3784L17.5301 20.485L16.7924 19.7472Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5305 16.7961L18.6371 15.6895L19.3748 16.4272L18.2682 17.5338L17.5305 16.7961Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6861 18.6404L16.7927 17.5338L17.5304 18.2716L16.4238 19.3782L15.6861 18.6404Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6421 8.31259L15.6911 5.36165L16.4289 4.62391L19.3798 7.57485L18.6421 8.31259Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6906 7.57513L14.584 6.46854L15.3217 5.73083L16.4283 6.83742L15.6906 7.57513Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5349 9.41995L16.4283 8.31335L17.166 7.57564L18.2726 8.68224L17.5349 9.41995Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9036 5.36154L16.797 4.25494L17.5347 3.5172L18.6413 4.6238L17.9036 5.36154Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7489 7.20657L18.6423 6.09998L19.38 5.36223L20.4866 6.46883L19.7489 7.20657Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25409 16.794L7.20503 19.7449L6.46729 20.4827L3.51635 17.5318L4.25409 16.794Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2049 17.5312L8.31149 18.6378L7.57378 19.3755L6.46719 18.2689L7.2049 17.5312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.36041 15.6872L6.46701 16.7938L5.72927 17.5315L4.62267 16.4249L5.36041 15.6872Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.46716 14.5803L9.4181 17.5312L8.68036 18.2689L5.72942 15.318L6.46716 14.5803Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20477 4.25266L4.25383 7.2036L3.51609 6.46585L6.46703 3.51491L7.20477 4.25266Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31134 5.35913L5.3604 8.31007L4.62266 7.57233L7.5736 4.62139L8.31134 5.35913Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41901 6.46643L6.46807 9.41737L5.73036 8.67966L8.6813 5.72872L9.41901 6.46643Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthkorea);
export default __webpack_public_path__ + "static/media/southkorea.3ef7a611145e192a1e4bbfd1d0174956.svg";
export { ForwardRef as ReactComponent };